import Loading from "components/Loading";
import React from "react";


export default function LoadingSurvey() {
  return <div className={"mx-auto"}>
    <Loading className={"mt-16"} loadingText={"Loading Survey..."}/>
  </div>;
}
